import keycloakService from '../../keycloak_service';

import { postToSinatra } from '../api_utils';

const removePipelineVersions = (pipeline_versions) => {
  const keycloakHeader = keycloakService.getAuthHeader();
  const fetchOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: keycloakHeader,
    },
    body: JSON.stringify({
      pipeline_versions,
    })
  };

  return postToSinatra('v1/api/pipelines/delete_pipeline_versions', fetchOptions);
};

export default removePipelineVersions;
